import { Component, HostListener } from '@angular/core';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { Location } from '@angular/common';

declare var $: any;

@Component({
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent {

  showAltHeader: boolean = false;

  languages: any[] = [];
  //restaurants: any = null;
  listRestaurants: any = null;
  listTypes: any = null;
  activeListTypeId: number = 0;
  selectedLanguage: any = {};

  region: any = null;
  regionImageUrl: string;
  friendlyUrl: string;
  listTypeFirendlyUrl: string;
  sortByFilter: any = [
    { value: 0, displayName: "DisplayOrder", urlValue: 'displayOrder' },
    { value: 1, displayName: "Rank", urlValue: 'rank' },
    { value: 2, displayName: "Restaurant", urlValue: 'restaurant' },
    { value: 3, displayName: "Chef", urlValue: 'chef' },
    { value: 4, displayName: "Cuisine", urlValue: 'cuisine' },
    { value: 5, displayName: "City", urlValue: 'city' },
    { value: 6, displayName: "List", urlValue: 'list' }
  ];
  selectedSortByFilter = 8; //SD220623: new ordering - by region rank
  sortByDirection: string = 'ASC';
  isSticky: boolean = false;
  showMobileLanguageMenu: boolean = false;

  currentPage: number = 1;
  resultsPerPage: number = 8;

  loadingListRestaurants: boolean;

  constructor(private _http: Http,
    private router: Router,
    private _lightbox: Lightbox,
    private location: Location,
    private route: ActivatedRoute) {

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var $tabNavSlider = $('.tabs .tabs__nav ul');
    var $win = $(window);
    var tabNavSliderOptions = {
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: false,
      speed: 500,
      variableWidth: true
    };

    if ($win.width() < 768) {
      this.initSlider($tabNavSlider, tabNavSliderOptions);
      $tabNavSlider.find('.slick-slide').on('click', function (event) {
        var $thisSlide = $(this);
        var thisIndex = $thisSlide.attr('data-slick-index');
        var $thisParent = $thisSlide.closest('.section-slider ul');
        var activeSlides = $thisParent.find('.slick-active').length;
        var goToSlide = thisIndex - activeSlides - 1;
        $tabNavSlider.slick('slickGoTo', goToSlide);
      });
    } else if ($win.width() > 767) {
      this.destroySlider($tabNavSlider);
    }
  }

  initSlider($selector, options) {
    if ($selector.length && !$selector.hasClass('slick-initialized')) {
      $selector.slick(options);
    }
  }

  destroySlider($selector) {
    if ($selector.length && $selector.hasClass('slick-initialized')) {
      $selector.slick('unslick');
    }
  }

  open(src): void {
    // open lightbox
    var albums = [
      {
        src: src,
        thumb: src
      }];

    this._lightbox.open(albums, 0);
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    if (!this.showAltHeader) {
      var header = document.getElementById("myHeader");
      var headerHeight = header ? header.offsetHeight : 0;
      this.isSticky = window.pageYOffset >= headerHeight;
    }
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.setQueryParams(params);

      //console.log("114.params=", params);

    });

    this.route.params.subscribe(params => {
      this.setRouteArgs(params);

    })
  }

  setQueryParams(params) {
    if (params['sort'] !== undefined && params['sort'] !== null) {
      var sort = params["sort"];
      this.selectedSortByFilter = this.sortByFilter.filter((o) => {
        return (o.urlValue == sort);
      })[0].value;
    }

    if (params["sortByDir"] !== undefined && params['sortByDir'] !== null) {
      this.sortByDirection == params["sortByDir"];
    }

    //if (params["view"] !== undefined && params['sort'] !== null) {
    //  var type = params["view"];
    //  if (type === 'list') {
    //    $('.tabs__sort-view .list').closest('.tabs').find('.tab').addClass('list-view');
    //    $('.list-filters').removeClass('hidden');
    //  }      
    //}
    //else {
    //  $('.tabs__sort-view .list').closest('.tabs').find('.tab').removeClass('list-view');
    //  $('.list-filters').addClass('hidden');
    //}
  }

  setRouteArgs(params) {
    this.friendlyUrl = params.friendlyUrl;
    if (params.listTypeFriendlyUrl) {
      this.listTypeFirendlyUrl = params.listTypeFriendlyUrl;
    }
    this.getRegion();
  }

  viewChanged(type) {

    //console.log("viewChanged called.type=" + type);

    this.router.navigate(['/dining-guide/' + this.friendlyUrl],
      {
        queryParams: {
          view: type === 'list' ? type : null
        }, queryParamsHandling: 'merge'
      });
  }

  getRegion() {
    this._http.get("region/getbyfriendlyUrl/" + this.friendlyUrl).toPromise().then((data) => {
      this.region = data.json();

      //console.log("this.region=", this.region);

      if (this.region.level == 2) {
        this.showAltHeader = true;
      }
      else if (this.region.level == 3) {
        this.showAltHeader = false;
        this.regionImageUrl = "url('/images/country/" + this.region.parent.friendlyUrl + "/" + this.region.friendlyUrl + ".png')";
      }

      //via getLanguages we call getListRestaurants()
      this.getLanguages();

    }).catch();
  }

  /*
  sort() {

    switch (this.selectedSortByFilter) {

      //defualt (landing sort: a combo of list and rank; provided from SP by displayOrder field)
      case 0:
        this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
          if (obj1.displayOrder > obj2.displayOrder) {
            return 1;
          }
          if (obj1.displayOrder < obj2.displayOrder) {
            return -1;
          }
          return 0;
        });
        break;

      //rank
      case 1:
        this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
          if (obj1.rank > obj2.rank) {
            return 1;
          }
          if (obj1.rank < obj2.rank) {
            return -1;
          }
          return 0;
        });
        break;

      //name
      case 2:
        this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
          if (obj1.name > obj2.name) {
            return 1;
          }
          if (obj1.name < obj2.name) {
            return -1;
          }
          return 0;
        });
        break;

      //chef
      case 3:
        this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
          if (obj1.chef > obj2.chef) {
            return 1;
          }
          if (obj1.chef < obj2.chef) {
            return -1;
          }
          return 0;
        });
        break;

      //cuisine
      case 4:
        this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
          if (obj1.cuisine > obj2.cuisine) {
            return 1;
          }
          if (obj1.cuisine < obj2.cuisine) {
            return -1;
          }
          return 0;
        });
        break;

      //city
      case 5:
        this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
          if (obj1.city > obj2.city) {
            return 1;
          }
          if (obj1.city < obj2.city) {
            return -1;
          }

          if (obj1.rank > obj2.rank) {
            return 1;
          }
          if (obj1.rank < obj2.rank) {
            return -1;
          }
          return 0;
        });
        break;

      //listTypeName
      case 6:
        this.listRestaurants = this.listRestaurants.sort((obj1, obj2) => {
          if (obj1.listTypeName > obj2.listTypeName) {
            //console.log("F6=listTypeName,1");
            return 1;
          }
          if (obj1.listTypeName < obj2.listTypeName) {
            //console.log("F6=listTypeName,-1");
            return -1;
          }

          if (obj1.rank > obj2.rank) {
            //console.log("F6=rank,1");
            return 1;
          }
          if (obj1.rank < obj2.rank) {
            //console.log("F6=rank,-1");
            return -1;
          }

          return 0;
        });
        break;
      }


  }
  */

  onLanguageChange(languageCode) {

    //this.router.navigate(['/lists/' + this.continentFriendlyUrl + '/' + this.listTypeFriendlyUrl + '/' + this.selectedYear],
    //  {
    //    queryParams: {
    //      lang: languageId
    //    }, queryParamsHandling: 'merge'
    //  });

    window.location.href = window.location.pathname + "?lang=" + languageCode;
  }

  getLanguages() {
    this._http.get("/languages").toPromise().then((data) => {
      this.languages = data.json();
      this.selectedLanguage = this.languages.find((x) => { return x.selected; });
      this.getListRestaurants();
      //console.log("328:getLanguages().languages=", this.languages);
      //console.log("329:getLanguages().selectedLanguage=", this.selectedLanguage);
    });
  }

  toggleMobileLanguageMenu() {
    this.showMobileLanguageMenu = !this.showMobileLanguageMenu;
  }

  /*
  onSortByChange(value) {

    //if (this.selectedSortByFilter == value) {
    //  if (this.sortByDirection == "ASC") {
    //    this.sortByDirection = "DESC";
    //  }
    //  else {
    //    this.sortByDirection = "ASC";
    //  }
    //}
    //else {
    //  this.sortByDirection = "ASC";
    //}

    this.selectedSortByFilter = value;
    if ($(".sortClose").is(":visible")) {
      $(".sortClose").click();
    }   

    if (value === 0) {
      //console.log("go to root");
      this.router.navigate(['/dining-guide/' + this.friendlyUrl]);
    }
    else {
      //console.log("original code here");
      this.router.navigate(['/dining-guide/' + this.friendlyUrl],        
        {
          queryParams: {
            sort: this.sortByFilter.filter((o) => {
              return (o.value == this.selectedSortByFilter);
            })[0].urlValue,
            sortByDir: this.sortByDirection === "ASC" ? null : this.sortByDirection
          },
          queryParamsHandling: 'merge'
        }
      );
    }


    //this.getListRestaurants();

    //console.log("onSortByChange clicked;value=" + value);

    this.sort();
  }
  */

  getListRestaurants() {

    //this.listRestaurants = null;
    //this.listTypes = null;
    this.loadingListRestaurants = true;

    //no need to pass language from here (it's in context and base controller has access to it)
    var postData = {
      RegionNewId: this.region.id,
      SortByDirection: this.sortByDirection,
      SortBy: this.selectedSortByFilter,
      //ListTypeId: listTypeId
      ListTypeFriendlyUrl: this.listTypeFirendlyUrl
      //StartIndex: (this.currentPage - 1) * this.resultsPerPage,
      //Take: this.resultsPerPage
    }

    this._http.post("/dining-guide-with-list-type/" + this.region.id,
      JSON.stringify(postData),
      {
        headers: new Headers({ 'Content-Type': 'application/json' })
      }).toPromise()
      .then((data) => {
        var response = data.json();
        this.currentPage++;

        if (!this.listTypes) {
          this.listTypes = response.listTypes;
        }
        else {
          response.listTypes.forEach((o) => {
            if (o.listType.friendlyUrl == this.listTypeFirendlyUrl) {
              this.listTypes.filter(x => x.listType.friendlyUrl == this.listTypeFirendlyUrl)[0].restaurants = o.restaurants;
            }
          });
        }

        //this.listTypes[0].isActive = true;
        this.listTypes.forEach((o, index) => {
          if ((o.listType.friendlyUrl == this.listTypeFirendlyUrl) || (!this.listTypeFirendlyUrl && index == 0)) {
            o.isActive = true;
            o.gotData = true;
            this.activeListTypeId = o.listType.id;
          }
          else {
            o.isActive = false;
          }
        })

        //this.restaurants = response.data;
        this.listTypes.forEach((o, index) => {
          if ((o.listType.friendlyUrl == this.listTypeFirendlyUrl) || (!this.listTypeFirendlyUrl && index == 0)) {
            this.listRestaurants = o.restaurants;
            //console.log("l type=", o.listType);
            //console.log("l Rests=", this.listRestaurants);
          }
        });
        this.loadingListRestaurants = false;

      }).catch();

  }

  onListTypeChange(lt, event) {
    //console.log("onListTypeChange.lt=", lt);
    event.preventDefault();
    //this.router.navigate(['/dining-guide/' + this.friendlyUrl + '/' + lt.listType.friendlyUrl]);
    this.location.go('/dining-guide/' + this.friendlyUrl + '/' + lt.listType.friendlyUrl);

    this.listTypeFirendlyUrl = lt.listType.friendlyUrl;

    if (!lt.gotData) {
      this.getListRestaurants();
    }
    else {
      for (let i = 0; i < this.listTypes.length; i++) {
        var item = this.listTypes[i];
        item.isActive = item.listType.id == lt.listType.id;
      }
      //lt.isActive = true;
      this.activeListTypeId = lt.listType.id;
      //console.log("413.activeListTypeId=", this.activeListTypeId);

      this.listTypes.forEach((o) => {
        if (o.listType.id == this.activeListTypeId) {
          this.listRestaurants = o.restaurants
        }
      });

    }
  }




  //togglecardView(value) {
  //  if (this.cardViewSelected && value === 1) {
  //    this.cardViewSelected = false;
  //  }
  //  else if (!this.cardViewSelected && value === 0) {
  //    this.cardViewSelected = true;
  //  }
  //}

  //showLanguageMenu() {
  //  var $win = $(window);
  //  var $body = document.getElementsByTagName("body")[0];
  //  var $languageMenu = document.getElementsByClassName("language__submenu")[0];

  //  $body.classList.add('filters-open');
  //  $languageMenu.classList.add('show');
  //}

  //hideLanguageMenu() {
  //  var $closeBtn = document.getElementsByClassName("sortClose")[0];
  //  var $body = document.getElementsByTagName("body")[0];
  //  var $languageMenu = document.getElementsByClassName("language__submenu")[0];

  //  $body.classList.remove('filters-open');
  //  $languageMenu.classList.remove('show');
  //}

  hideLanguageMenu() {
    this.showMobileLanguageMenu = false;
  }

}
